import BottomSlideIn from "./BottomSlideIn";
import { useEffect, useState } from "react";

const PopUpLayout = ({ children }) => {

    const [visibleFix, setVisibleFix] = useState(false);

    useEffect(() => {
        setTimeout(function() {
            setVisibleFix(true);
        }, 100);
    }, []);

    return (
        <div className={`${visibleFix && 'slide-enter-done'}`}>
            <BottomSlideIn>
                {children}
            </BottomSlideIn>
        </div>
    );
}

export default PopUpLayout;
